import { render, staticRenderFns } from "./injuryTypes.vue?vue&type=template&id=5fa8d11c&scoped=true"
import script from "./injuryTypes.vue?vue&type=script&lang=js"
export * from "./injuryTypes.vue?vue&type=script&lang=js"
import style0 from "./injuryTypes.vue?vue&type=style&index=0&id=5fa8d11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa8d11c",
  null
  
)

export default component.exports